import cn from 'classnames'
import {
  bindMenu,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'

import {
  AppBar,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from '@material-ui/core'
import {
  ChevronRight,
  ExitToApp as ExitIcon,
  ExpandMore as ExpandMoreIcon,
  HelpOutline as HelpIcon,
  HomeRounded as HomeIcon,
  Menu as MenuIcon,
  Person as PersonIcon,
  Settings,
  Web as WebIcon
} from '@material-ui/icons'

import auctionSnapIcon from '../../../../icons/auctionsnap-icon.png'
import eventSnapIcon from '../../../../icons/eventsnap-icon.png'
import { Logo } from '../../../../icons/Logo'
import { useFetchEventData } from '../../../../queries/events/useFetchEvents'
import { logout } from '../../../../slices/authSlice'
import styles from './Header.module.css'

// import { logout, useCurrentUser } from '@slices/authSlice'

const AUCTIONSNAP_SUPPORT_URL = 'https://auctionsnap.com/support'
const EVENTSNAP_SUPPORT_URL = 'https://eventsnap.com/support'

const openSupportSite = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

const Header = ({ showMenu, isOpen, setIsOpen }) => {
  const popupState = usePopupState({ variant: 'popover', popupId: 'demoMenu' })
  const helpPopupState = usePopupState({ variant: 'popover', popupId: 'helpMenu' })
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { data: eventsData } = useFetchEventData()

  const inAuctionModule = location.pathname.startsWith('/auction/')
  const inEventModule = location.pathname.startsWith('/event/')
  const hasAuctionSubscription = !!eventsData?.validauction
  const hasEventSubscription = !!eventsData?.validevent
  const hasBothSubscriptions = hasAuctionSubscription && hasEventSubscription

  const directSupportUrl = inAuctionModule
    ? AUCTIONSNAP_SUPPORT_URL
    : inEventModule
      ? EVENTSNAP_SUPPORT_URL
      : hasBothSubscriptions
        ? null
        : hasAuctionSubscription
          ? AUCTIONSNAP_SUPPORT_URL
          : hasEventSubscription
            ? EVENTSNAP_SUPPORT_URL
            : null
  const showHelpDropdown = !directSupportUrl && hasBothSubscriptions

  const redirectToLogin = () => {
    dispatch(logout())
    history.push('/auth/login')
  }
  const redirectToHome = () => {
    history.push('/home')
  }
  return (
    <AppBar
      position="absolute"
      className={cn(styles.appBar, isOpen && styles.shift)}>
      <Toolbar className={styles.toolbar}>
        {showMenu && (
          <HomeIcon
              onClick={() => redirectToHome()}
              classes={{ root: cn(styles.menuButton) }} fontSize="large">
          </HomeIcon>
        )}

        <div className={styles.logoWrapper}>
          <Link to="/home">
            <Logo />
          </Link>
        </div>
        <div className={styles.rightSection}>
          {directSupportUrl && (
            <div
              className={styles.helpButton}
              onClick={() => openSupportSite(directSupportUrl)}>
              <HelpIcon className={styles.helpIcon} />
              <span>Help</span>
            </div>
          )}

          {showHelpDropdown && (
            <div
              className={styles.helpButton}
              {...bindTrigger(helpPopupState)}>
              <HelpIcon className={styles.helpIcon} />
              <span>Help</span>
              <ExpandMoreIcon className={styles.helpChevron} />
            </div>
          )}

          <div
            style={{ display: 'flex', alignItems: 'center' }}
            {...bindTrigger(popupState)}>
            {/* <Typography>{user?.firstname}</Typography> */}
            <Avatar className={styles.avatar} />
            <IconButton color="inherit">
              <ChevronRight className={styles.arrow} />
            </IconButton>
          </div>
        </div>

        <Menu {...bindMenu(helpPopupState)} style={{ top: 40 }}>
          <MenuItem
            onClick={() => {
              helpPopupState.close()
              openSupportSite(EVENTSNAP_SUPPORT_URL)
            }}>
            <img src={eventSnapIcon} className={styles.helpMenuIcon} alt="" />
            EventSnap support
          </MenuItem>
          <MenuItem
            onClick={() => {
              helpPopupState.close()
              openSupportSite(AUCTIONSNAP_SUPPORT_URL)
            }}>
            <img
              src={auctionSnapIcon}
              className={styles.helpMenuIcon}
              alt=""
            />
            AuctionSnap support
          </MenuItem>
        </Menu>

        <Menu {...bindMenu(popupState)} style={{ top: 40 }}>
          {/* <MenuItem onClick={onWebsiteClick}>
            <WebIcon style={{ marginRight: 10 }} />
            Website
          </MenuItem>
          <MenuItem onClick={onProfileClick}>
            <PersonIcon style={{ marginRight: 10 }} />
            My Profile
          </MenuItem> */}
          <MenuItem onClick={() => redirectToLogin()}>
            <ExitIcon style={{ marginRight: 10 }} />
            Sign Out
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default Header
